module.exports = __webpack_public_path__ + "img/e.16f5e40c.svg";